import { render, staticRenderFns } from "./C-Section.vue?vue&type=template&id=12d8a664&scoped=true&"
import script from "./C-Section.vue?vue&type=script&lang=js&"
export * from "./C-Section.vue?vue&type=script&lang=js&"
import style0 from "./C-Section.vue?vue&type=style&index=0&id=12d8a664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8a664",
  null
  
)

export default component.exports